import {EnumLanguage} from "../EnumLanguage";

export const UXDemo = {
    description: {
        [EnumLanguage.en]: 'MIS is designed to computerize and systematize the accounting, storage, scientific and exposition activities of the museum.',
        [EnumLanguage.ru]: 'МИС предназначена для компьютеризации и систематизации учетно-хранительской, научной и экспозиционной деятельности музея.'
    }, 
    needAuthorization:{
        [EnumLanguage.en]: 'In order to open the "Demo" you need to be logged in to your account and fill out all profile information.',
        [EnumLanguage.ru]: 'Для того что бы открыть «Демо» нужно войти в свою учетную запись и заполнить все данные профиля.'
    }
}